

import { defineComponent } from 'vue'
import cookie from 'cookie'

// declare module 'vue/types/vue' {
//     interface Vue {
//         isVisible: boolean
//         isVisibleAnimation: boolean
//         invitation: number
//         state: number
//     }
// }

enum State {
    Waiting = 0,
    Show = 1,
    Hide = 2,
}

export default defineComponent({
    data () {
        return {
            isVisible: false,
            isVisibleAnimation: false,
            state: State.Hide,
        }
    },
    created () {
        const invitation = parseInt(cookie.parse(document.cookie).dek_invitation)
        const cookies = cookie.parse(document.cookie).dek_cookies

        if (cookies === undefined) {
            this.setCookie(State.Show)
            this.state = State.Hide
            return
        }

        if (isNaN(invitation) || invitation < 0 || invitation > 2) {
            this.state = State.Waiting
        } else {
            this.state = invitation
        }
    },
    mounted () {
        if (this.state === State.Hide) {
            return
        }

        document.addEventListener('click', (e: MouseEvent) => {
            const invitation = this.$refs.invitation as EventTarget
            if (this.isVisible && e.composedPath().indexOf(invitation) === -1) {
                this.hide()
            }
        })

        if (this.state === State.Show) {
            this.show()
        }

        if (this.state === State.Waiting) {
            this.setCookie(State.Show)
            setTimeout(() => {
                this.show()
            }, 10 * 1000)
        }
    },
    computed: {
        shopId () {
            return window.config.getShopId()
        },
    },
    methods: {
        show () {
            this.isVisible = true
            setTimeout(() => {
                this.isVisibleAnimation = true
            }, 0)
            this.setCookie(State.Hide)
        },
        hide () {
            this.isVisibleAnimation = false
            setTimeout(() => {
                this.isVisible = false
            }, 350)
        },
        setCookie (state:number) {
            const invitation = cookie.serialize('dek_invitation', String(state), {
                httpOnly: false, // if true -> client cant access it
                maxAge: 60 * 60 * 24 * 30, // 30 days
                secure: true, // https only
                sameSite: 'strict',
                path: '/',
            })
            document.cookie = invitation
        },
    },
})
